import { ProductLayout } from "../components/ProductLayout";
import { ReactNode } from "react";

export const IPOLayout = ({ children }: { children: ReactNode }) => {
  return <ProductLayout>{children}</ProductLayout>;
};
